
import { Routes, Route, Navigate } from "react-router-dom";
import Cookies from 'js-cookie';
import Authentication from "./authentication/authentication.component";
import Dashboard from '../../components/dashboard/Dashboard'
import AllTransaction from "../../components/transaction/AllTransaction";
import AllTransactionReport from "../../components/transaction/AllTransactionReport";
import Layout from "../../components/Layout/Layout";
import ResetPasswordForm from "../../components/reset_password/ResetPassword";
import NotFoundPage from "../../components/not_found_page/NotFoundPage";
import ProjectList from "../../components/projectManagement/ListProject";
import ListLocation from "../../components/locationManagement/ListLocation";
import ListDestination from "../../components/destinationManagement/ListDestination";
import EditTransaction from "../../components/transaction/EditTransaction";
import DetailsTransactions from "../../components/transaction/DetailsTransactions";
import AddDestination from "../../components/destinationManagement/AddDestination";
import EditDestination from "../../components/destinationManagement/EditDestination";


const ProtectedRoute = () => {
    
    return (
        <>
            <Layout />
        </>
    )
};

const SuperAdmin = () => {

    return (
        <Routes>
            <Route index element={<Authentication />} />

            <Route path="/" element={<ProtectedRoute />}  >
                <Route path="dashboard" element={<Dashboard />} />
                {/* <Route path="brand" element={<Brandingpage />} />
                <Route path="customer" element={<Customerpage />} />
                <Route path="customer-detail/:id/:customer_name" element={<CustomerDetails />} /> */}



                {/* <Route path="brand-detail/:id" element={<BrandDetail />} />
                <Route path="campaign" element={<Campaign />} /> 
                <Route path="transaction" element={<AllTransaction />} />
                <Route path="voucher" element={<Voucher />} />
                <Route path="supportquery" element={<SupportQuery />} />
                <Route path="setting/category" element={<Category />} />
                <Route path="setting/country" element={<Country/>} />
                <Route path="setting/document" element={<Document/>} />
                <Route path="setting/globalSetting" element={<GlobalSetting />} />
                <Route path="user-mangement/customer" element={<CustomerList />} />
                <Route path="customer-list" element={<CustomerList />} />
                <Route path="user-mangement/admin" element={<AdminList />} />*/}
                <Route path="reset-password" element={<ResetPasswordForm />} /> 
                <Route path="project-management" element={<ProjectList />} />
                <Route path="location-management" element={<ListLocation />} />
                <Route path="destination-management" element={<ListDestination />} />
                <Route path="destination-management/edit/:id" element={<EditDestination />} />
                <Route path="transaction" element={<AllTransaction />} />
                <Route path="transaction-report" element={<AllTransactionReport />} />
               
                <Route path="transaction/:id" element={<AllTransaction />} />
                <Route path="edit-Transaction/:id" element={<EditTransaction />} />
                <Route path="report-details/:reportid/:id" element={<DetailsTransactions />} />
                
            </Route>
            <Route path="/*" element={<NotFoundPage />} />
        </Routes>

    )
}

export default SuperAdmin



